import React, { Fragment } from 'react';
import { translate } from '../Services/translation';

const MiniCartErrorMessage = ({css, close}) => (
    <div className={`${css}`}>
            <div>{translate("minicart.addedtoomanyproducts")}</div>
            <i className="ph-x" onClick={() => close()}></i>
    </div>
)

export default MiniCartErrorMessage;